// Copyright (c) 2025 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/type/selected_timesheet_field_option.proto (package wisetime.user.type, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/type/selected_timesheet_field_option.proto.
 */
export const file_wisetime_user_type_selected_timesheet_field_option: GenFile = /*@__PURE__*/
  fileDesc("Cjh3aXNldGltZS91c2VyL3R5cGUvc2VsZWN0ZWRfdGltZXNoZWV0X2ZpZWxkX29wdGlvbi5wcm90bxISd2lzZXRpbWUudXNlci50eXBlIm4KHFNlbGVjdGVkVGltZXNoZWV0RmllbGRPcHRpb24SDwoHc2l0ZV9pZBgDIAEoCRIaChJ0aW1lc2hlZXRfZmllbGRfaWQYASABKAkSIQoZdGltZXNoZWV0X2ZpZWxkX29wdGlvbl9pZBgCIAEoCUJBChpjb20ud2lzZXRpbWUuYXBpLnVzZXIudHlwZUIhU2VsZWN0ZWRUaW1lc2hlZXRGaWVsZE9wdGlvblByb3RvUAFiBnByb3RvMw");

/**
 * @generated from message wisetime.user.type.SelectedTimesheetFieldOption
 */
export type SelectedTimesheetFieldOption = Message<"wisetime.user.type.SelectedTimesheetFieldOption"> & {
  /**
   * @generated from field: string site_id = 3;
   */
  siteId: string;

  /**
   * @generated from field: string timesheet_field_id = 1;
   */
  timesheetFieldId: string;

  /**
   * @generated from field: string timesheet_field_option_id = 2;
   */
  timesheetFieldOptionId: string;
};

/**
 * Describes the message wisetime.user.type.SelectedTimesheetFieldOption.
 * Use `create(SelectedTimesheetFieldOptionSchema)` to create a new message.
 */
export const SelectedTimesheetFieldOptionSchema: GenMessage<SelectedTimesheetFieldOption> = /*@__PURE__*/
  messageDesc(file_wisetime_user_type_selected_timesheet_field_option, 0);

